module.exports = __webpack_public_path__ + "img/profile_banner.a23ccc30.png";